import type { PopperContentProps } from '@radix-ui/react-popper';
import type { ReactNode } from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'shared/ui/tooltip';
interface TooltipWrapperProps {
  children: ReactNode;
  content: string | ReactNode;
  side?: PopperContentProps['side'];
  sideOffset?: PopperContentProps['sideOffset'];
}
export const TooltipWrapper = ({
  children,
  content,
  side = 'bottom',
  sideOffset
}: TooltipWrapperProps) => {
  return <TooltipProvider delayDuration={200} data-sentry-element="TooltipProvider" data-sentry-component="TooltipWrapper" data-sentry-source-file="tooltip-wrapper.tsx">
      <Tooltip data-sentry-element="Tooltip" data-sentry-source-file="tooltip-wrapper.tsx">
        <TooltipTrigger asChild data-sentry-element="TooltipTrigger" data-sentry-source-file="tooltip-wrapper.tsx">{children}</TooltipTrigger>
        <TooltipContent side={side} sideOffset={sideOffset} data-sentry-element="TooltipContent" data-sentry-source-file="tooltip-wrapper.tsx">
          {typeof content === 'string' ? <p className="text-body3">{content}</p> : content}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>;
};